import { AppStatus } from '@/redux'
import { Topic } from '../../../utils/hooks/topic' //WTF!
import { checkSignupCompletion } from './checkSignupCompletion'
import { maybeOpenRegistrationWall } from '../unknownProfile'
import { ensureEmailVerified } from './ensureEmailVerified'
import { isLoggedIn } from './utils'
import { QueryKeys } from './queryKeys'

export const ensureProfileDetailsTopic = Topic.named<boolean>('ensureProfileDetails')
export async function ensureProfileDetails() {
  const profile = QueryKeys.me.getData()
  const { isComplete, nextStep, modal } = await checkSignupCompletion(profile)

  console.debug('Profile completion', { isComplete, nextStep, modal, profile })

  if (!isComplete) {
    AppStatus.setModal(modal ?? nextStep as any)

    const response = await ensureProfileDetailsTopic.wait(null)
    if (!response) {
      throw new Error('Profile not complete', { cause: 'ensureProfileDetails' })
    }
  }

  await ensureEmailVerified(profile)
}

export const ensureLoggedInTopic = Topic.named<boolean>('ensureLoggedIn')
export async function ensureLoggedIn() {
  const loggedIn = isLoggedIn()

  if (!loggedIn) {
    maybeOpenRegistrationWall()

    const response = await ensureLoggedInTopic.wait(null)
    if (!response) {
      throw new Error('User is not logged in', { cause: 'ensureLoggedIn' })
    }
  }

  return loggedIn
}

export async function ensureProfileCompletion(checkProfileDetails?: boolean): Promise<void> {
  await ensureLoggedIn()

  if (checkProfileDetails) {
    await ensureProfileDetails()
  }
}
